import { render, staticRenderFns } from "./LeadsCardEdit.vue?vue&type=template&id=5979b495&scoped=true&"
import script from "./LeadsCardEdit.vue?vue&type=script&lang=js&"
export * from "./LeadsCardEdit.vue?vue&type=script&lang=js&"
import style0 from "./LeadsCardEdit.vue?vue&type=style&index=0&id=5979b495&lang=scss&scoped=true&"
import style1 from "./LeadsCardEdit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5979b495",
  null
  
)

export default component.exports